module.exports = __webpack_public_path__ + "img/so_develop.94a71b12.png";